const RateStars = () => {
  const rateStars = document.querySelector(".rate__stars");

  if (rateStars) {
    const stars = [...rateStars.querySelectorAll(".rate__star i")];

    stars.forEach((star, index) => {
      star.addEventListener("mouseenter", function () {
        highlightStars(index);
      });

      star.addEventListener("click", function () {
        highlightStars(index);
      });
    });

    function highlightStars(index) {
      stars.forEach((star, i) => {
        if (i <= index) {
          star.classList.add("active");
          console.log("Chosed stars:", index + 1);
        } else {
          star.classList.remove("active");
        }
      });
    }
  }
};

export default RateStars;
